export default theme => {
    return {}
}



// WEBPACK FOOTER //
// ./src/app/configuration/CategoryTentpoleEvents/theme/components/scorecard/MetricsLabels/index.js